export const CLIENT_FILTER = {
  status: "active",
};
